import React from 'react'
import { hardcodeDropdown } from "../services";
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import { Dialog } from '@mui/material';
import { ReactComponent as CloseIcon } from "assets/img/svg/CloseIcon.svg"
import ALoader from 'views/pages/manage/common/a-loader';
import styles from "../styles.module.scss";
import { openInNewTab } from 'modules/studentRefund/common/services';

export const labelStyle = {
    fontWeight: 600,
    fontSize: '12px',
    color: '#262626'
}

const AddEditConfigDialog = ({
    open,
    form,
    setForm,
    handleForm,
    dropdownData,
    handleClose,
    createUpdateConfigHandler,
    buLoading,
    loading
}) => {
    const { allActiveBu, allActiveYear, allActiveRoles } = dropdownData;

    // const updateRoles = (level, roles) => {
    //     setForm(prev => ({
    //         ...prev,
    //         rolesByLevel: {
    //             ...prev.rolesByLevel,
    //             [level]: roles
    //         }
    //     }));
    // };

    const updateRoles = (level, roles) => {
        setForm(prev => {
            const updatedRoles = {
                ...prev.rolesByLevel,
                [level]: roles
            };

            for (let i = level + 1; i <= 4; i++) {
                updatedRoles[i] = [];
            }

            return {
                ...prev,
                rolesByLevel: updatedRoles
            };
        });
    };

    const getRolesByLevel = (level) =>
        form?.rolesByLevel?.[level] || [];


    const approvalLevels = [1, 2, 3, 4];

    const isLevelEnabled = (level) => {
        if (level === 1) return true;
        return (getRolesByLevel(level - 1)?.length ?? 0) > 0;
    };

    const isLevelMandatory = (level) => level === 1;

    const isSaveDisabled = () => {
        const hasVendorType = !!form?.vendorType;
        const hasBusinessArea = form?.businessArea?.length > 0;
        const hasYear = form?.year?.length > 0;
        const hasL1Approver = form?.rolesByLevel?.[1]?.length > 0;

        return !(hasVendorType && hasBusinessArea && hasYear && hasL1Approver);
    };


    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
        >
            {loading && <ALoader position="fixed" />}
            <div className='p-3'>
                <div className='d-flex justify-content-between'>
                    <h4>Vendor Approval Configs</h4>

                    {/* <div className='d-flex align-items-center'> */}
                    {/* <AButton
                            variant="outline"
                            onClick={() => { openInNewTab(`vendorSetup/logs?configId=${encodeURIComponent(form?.id)}&eventType=${encodeURIComponent('APPROVAL_CONFIG')}`) }}
                            size="xs"
                        >
                            Logs
                        </AButton> */}
                    <CloseIcon width={20} height={20} onClick={handleClose} />
                    {/* </div> */}
                </div>

                <div className={styles['dropdown-container']}>
                    <div className={styles['label']}>1. Basic details</div>

                    <div className={styles['dropdowns']}>

                        <AAutoComplete
                            label='Business area*'
                            labelStyle={labelStyle}
                            items={allActiveBu}
                            handleChange={(val) => handleForm("businessArea", val)}
                            currentValue={form?.businessArea}
                            isShowCount
                            isLoading={buLoading}
                        />

                        <AAutoComplete
                            label='Year*'
                            labelStyle={labelStyle}
                            items={allActiveYear}
                            handleChange={(val) => handleForm("year", val)}
                            currentValue={form?.year}
                            isShowCount
                        />

                        <AAutoComplete
                            label='Vendor type*'
                            labelStyle={labelStyle}
                            items={hardcodeDropdown?.vendorTypes}
                            handleChange={(val) => handleForm("vendorType", val)}
                            currentValue={form?.vendorType}
                            // isShowCount
                            isMulti={false}
                        />

                    </div>

                </div>

                <div className={styles['dropdown-container']}>
                    <div className={styles['label']}>1. Approval settings</div>

                    <div className={styles['dropdowns']}>

                        {approvalLevels.map(level => {
                            const enabled = isLevelEnabled(level);
                            const mandatory = isLevelMandatory(level);

                            return (
                                <AAutoComplete
                                    key={level}
                                    label={`L${level} Approver${mandatory ? '*' : ''}`}
                                    labelStyle={labelStyle}
                                    currentValue={getRolesByLevel(level)}
                                    handleChange={(roles) => updateRoles(level, roles)}
                                    items={allActiveRoles}
                                    isMulti
                                    placeholder={
                                        enabled
                                            ? `Select L${level} roles`
                                            : `Fill L${level - 1} first`
                                    }
                                    isShowCount
                                    isDisabled={!enabled}
                                />
                            );
                        })}



                    </div>

                </div>

                <AButton
                    variant='primary_filled'
                    className='float-right mt-3'
                    onClick={() => {
                        // if (ref.current.isTableInEditMode) {
                        //     failureToast("Please save or discard current changes!");
                        //     return;
                        // }
                        createUpdateConfigHandler();
                    }}
                    disabled={isSaveDisabled()}
                >
                    Save Config
                </AButton>

            </div>
        </Dialog>
    )
}

export default AddEditConfigDialog;